export default {"src":"/_next/static/media/for-publishers-4.85294e6b.svg","height":1482,"width":1440};